import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorPage from './components/pages/error';
import AboutUs from './components/pages/about';
import { useEffect } from 'react';
import ScrollToTop from './components/pages/common/scroll/scroll-to-top';
import { animationCreate } from '.';
import SwitchTab from './components/pages/common/dark-light';
import HomeFour from './components/pages/homes/home-4';
import History from './components/pages/history';
import ContactUs from './components/pages/contacts';

function App() {
    useEffect(() => {
        setTimeout(() => {
            animationCreate();
        }, 500);
    }, []);

    return (
        <>
            <SwitchTab />

            <Router>
                <Routes>
                    <Route path="/" element={<HomeFour />} />
                    <Route path="/hakkimizda" element={<AboutUs />} />
                    <Route path="/projeler" element={<History />} />
                    <Route path="/iletisim" element={<ContactUs />} />

                    <Route path="*" element={<ErrorPage />} />

                    {/* ❌ KULLANILMAYAN SAYFALAR - DEVRE DIŞI */}
                    {/* <Route path="/services" element={<ServicePage />} /> */}
                    {/* <Route path="/services/:id" element={<ServicesDetails />} /> */}
                    {/* <Route path="/testimonial" element={<Testimonial />} /> */}
                    {/* <Route path="/pricing-plans" element={<PricingPages />} /> */}
                    {/* <Route path="/faq" element={<FaqPage />} /> */}
                    {/* <Route path="/team" element={<TeamPage />} /> */}
                    {/* <Route path="/team-two" element={<TeamPageTwo />} /> */}
                    {/* <Route path="/team-three" element={<TeamPageThree />} /> */}
                    {/* <Route path="/request-quote" element={<RequestQuotePage />} /> */}
                    {/* <Route path="/history1" element={<PortfolioFilterPage />} /> */}
                    {/* <Route path="/portfolio/2-columns" element={<PortfolioTowColumns />} /> */}
                    {/* <Route path="/portfolio/3-columns" element={<PortfolioThreeColumns />} /> */}
                    {/* <Route path="/portfolio/4-columns" element={<PortfolioFourColumns />} /> */}
                    {/* <Route path="/portfolio/:id" element={<PortfolioDetails />} /> */}
                    {/* <Route path="/blog" element={<BlogGrid />} /> */}
                    {/* <Route path="/blog-standard" element={<BlogStandardPage />} /> */}
                    {/* <Route path="/blog/:id" element={<BlogDetails />} */}
                </Routes>
            </Router>

            <ScrollToTop />
        </>
    )
}

export default App;